<script>
    import Dashboard from "../../Models/dashboardModel";
    import Loader from '../Loader.svelte';
    import {addFormModal} from '../../Forms/ModalFormManager.svelte';
    import {notifier} from '@beyonk/svelte-notifications';
    import {confirm} from '../Confirmation.svelte';
    import SortableTable from '../SortableTable.svelte';
    import { onMount } from "svelte";
import { handleError } from "../../Utilities/handlePromise";

    export let params;

    let  sortFields, formFields;
    let dashboard_model, dashboard;

    function addItem() {
        addFormModal({
            fields: formFields
        }).then(formData => {
            dashboard_model.addItem(formData).then(() => notifier.success("Item Added"));
        }, handleError);
    }

    function editItem(item) {
        addFormModal({
            fields: formFields,
            data: item
        }).then(formData => {
            dashboard_model.updateItem(formData).then(() => notifier.success("Item Saved"));
        }, handleError);
    }

    function deleteItem(item) {
        confirm("Are you sure you want to delete this item?").then(() => {
            dashboard_model.deleteItem(item).then(() => {
                notifier.success("Item Deleted");
            }, handleError);
        }, handleError);
    }


    onMount(() => {
        dashboard_model = new Dashboard(params.id);

        const unsub = dashboard_model.store.subscribe((lib) => {
            if (!lib) {
                return;
            }

            dashboard = lib;

            formFields = [
                {
                    "name": "Name",
                    "label": "Name"
                }
            ];
            sortFields = [{
                "field": "Name",
                "label": "Name"
            }];
            for (let field of dashboard.details.fields) {
                let formField = {
                    name: field.name,
                    label: field.name,
                    type: field.type,
                    required: field.required
                };
                if (field.type == "select") {
                    formField.choices = {
                        static: field.options
                    }
                    formField.dflt = field.options[0]
                }
                formFields.push(formField)

                if (field.show_in_table != undefined && field.show_in_table) {
                    sortFields.push({
                        field: field.name,
                        label: field.name
                    })
                }
            }

            // tell svelte it changed
            formFields = formFields;
            sortFields = sortFields;

        });

        return unsub;
    })
</script>

<Loader loading={!dashboard}>
    <div class="container is-fluid">
        <h1 class="title is-1">{dashboard.details.name}</h1>
        <SortableTable {sortFields} tableData={dashboard.items}>
            <div slot="filterActions"><button class="button is-success" on:click={addItem}>Add Item</button></div>
            <div slot="rowActions" let:row={item}>
                <div class="buttons is-centered">
                    <button class="button is-danger" on:click={() => deleteItem(item)}>Delete</button>
                    <button class="button is-link" on:click={() => editItem(item)}>Edit</button>
                </div>
            </div>
        </SortableTable>
    </div>
</Loader>